const search = {
  title: 'Hae sivustolta',
  placeholder: 'Mitä etsit?',
  btnText: 'HAE',
}

export default search